import { useEffect } from 'react';
import { useRouting } from './useRouting';

export function useRouterWillLeave(
  isUnsaved: boolean,
  {
    message = 'You have unsaved changes, are you sure you want to leave?',
  } = {},
) {
  const routing = useRouting();

  useEffect(() => {
    const { router, route } = routing;

    const handleRouteLeave = (nextLocation: string) => {
      if (isUnsaved) {
        return message;
      }
    };

    const removeHook = router.setRouteLeaveHook(route, handleRouteLeave);

    return () => {
      removeHook();
    };
  }, [routing.route, routing.router, isUnsaved, message]);
}
